export default __webpack_public_path__ + "static/media/abld_inverted_reading.2d1c101ff886e6a98417ed658f7d6659.svg";